import { createRouter } from '@tanstack/react-router';

import { routeTree } from './routeTree.gen';

export default createRouter({
  routeTree,
  // Render the root route's branded `notFoundComponent` for EVERY unmatched
  // path, at any depth. The default 'fuzzy' mode handles a not-found at the
  // nearest matched parent (e.g. `/auth/login11` stops at the `/auth` layout
  // route, which has no notFoundComponent) and falls back to TanStack's bare
  // "Not Found" text. 'root' bubbles all not-founds to the root component.
  notFoundMode: 'root',
  context: {
    // auth will initially be undefined
    // We'll be passing down the auth state from within a React component
    auth: undefined,
  },
});
